import {Injectable} from '@angular/core';
import {environment} from '@wms/app';
import {I18nService, WmHttpService} from "@wms/services";

@Injectable({
  providedIn: 'root'
})
export class LogsService {
  private TARGET: string = 'LOGS';
  private locale: any;
  private API_META: any = {
    serverLogs: {
      url: environment.SERVICES_BASE_PATH + "services/studio/logs/server/:serverLogsLineCount",
      method: "GET"
    },
    applicationLogs: {
      url: environment.SERVICES_BASE_PATH + "services/studio/logs/application/:applicationLogsLineCount",
      method: "GET"
    },
    RNBuildLogs: {
      url: environment.SERVICES_BASE_PATH + "services/studio/logs/react-native/:lineCount",
      method: "GET"
    },
  }

  constructor(private wmHttpService: WmHttpService, private i18nService: I18nService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.locale = this.i18nService.getMessages();
  }

  getApplicationLogs(applicationLogsLineCount: number): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "applicationLogs",
      pathParams: {
        applicationLogsLineCount: applicationLogsLineCount
      }
    }) as Promise<any>);
  }

  getServerLogs(serverLogsLineCount: number): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "serverLogs",
      pathParams: {
        serverLogsLineCount: serverLogsLineCount
      }
    }) as Promise<any>);
  }

  getRNBuildLogs(lineCount: number): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "RNBuildLogs",
      pathParams: {
        lineCount: lineCount
      }
    }) as Promise<any>);
  }


}
